const planos = [
    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( 2x/semana ) - anual",
        tx_adesão:"Grátis",
        duração:"12 meses",
        pagamento:"Em até 12x",
        parcela:"R$170,00",
        valorTotal:2040,
        source:"https://venda.nextfit.com.br/55e82903-42e0-4987-9f4f-acb4f3631461"
    },

    //{
    //    modalidade:"jiu jitsu",
    //    tipo:"- 2x/semana - semestral",
    //    tx_adesão:"Grátis",
    //    duração:"6 meses",
    //    pagamento:"Em até 6x",
    //    parcela:"R$180,00",
    //    valorTotal:1080,
    //    source:""
    //},
//
    //{
    //    modalidade:"lutas",
    //    tipo:"- 2x/semana - trimestral",
    //    tx_adesão:"Grátis",
    //    duração:"3 meses",
    //    pagamento:"Em até 3x",
    //    parcela:"R$190,00",
    //    valorTotal:570,
    //    source:""
    //},

    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( 2x/semana ) - mensal",
        tx_adesão:"Grátis",
        duração:"1 mês",
        pagamento:"À vista",
        parcela:"R$210,00",
        valorTotal:210,
        source:"https://venda.nextfit.com.br/2cf4b7ad-564c-451d-9d4b-527ef067867c"
    },

    // {
    //     modalidade:"promocional - jiu jitsu",
    //     tipo:" - recorrente",
    //     tx_adesão:"Grátis",
    //     duração:"3 meses",
    //     pagamento:"em até 3x",
    //     parcela:"R$299,00",
    //     valorTotal:897,
    //     source:""
    // },

    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( 2x/semana ) - recorrente",
        tx_adesão:"Grátis",
        duração:"12 meses",
        pagamento:"À vista",
        parcela:"R$149,00",
        valorTotal:149,
        source:"https://venda.nextfit.com.br/25034928-3049-4cbc-aed4-f11c56de52cf/contratos"
    },
]

export default planos;